<template>
    <transition name="vip-popup-fade">
        <div v-if="isPopupVisible" id="vip_popup" @click.self="close">
            <div class="vip_popup" @click.stop>
                <!-- 支付界面 -->
                <div v-if="!vipStatus">
                    <div class="top">
                        <!-- <img src="@/assets/image/icon_create3.png" class="top-close cursor_1" @click.self="close"/> -->
                          <svg-icon iconClass="del" class="custom top-close cursor_1 t-m-r-5" @click.self="close"/>
                    </div>
                    <main class="vip-main t-m-t-36">
                        <vipCharge :plans="pricingOptions" :initial-active-index="selectedPlan"
                            @plan-selected="handlePlanSelected" >
                        </vipCharge>
                    </main>
                    <div class="pay t-m-t-23">
                        <div class="pay-tips">
                            <p class="" v-for="(item,index) in vipTip" :key="index"> {{ item }}</p>
                        </div>
                        <div class="pay-type">
                            <vipPrice  :vipItem="vipItem" :userVipType="userInfo.vipType"></vipPrice>
                        </div>
                    </div>
                </div>
                <!-- 权益对比的界面 -->
                <div v-else>

                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import data from '@/assets/data';
import vipCharge from './dongeb/vipCharge.vue';//收费选项模式
// import vipQuanyi from '../components/vip_quanyi.vue' //vip权益
import vipPrice from '../components/vip_price.vue' //vip支付
import { EventBus } from '@/utils/eventBus';
import api from '@/api/api';
export default {

    components: {
        // vipQuanyi,
        vipPrice,
        vipCharge
    },
    data() {
        return {
            headImg: data.headImg, //用户头像 vip
            qunayiList: [], //权益对比
            isPopupVisible: false,
            vipStatus: 0, // 0会员 1会员权益
            userInfo: {}, //用户信息
            loginState: false, //登录状态
            vipTip: data.vipTip,
            selectedPlan: 0, // 默认选中第三个
            vipItem:{},//选择的套餐
            pricingOptions: []
        };
    },
    mounted() {
        EventBus.$on('openVip', () => {
            this.isPopupVisible = true;
            this.vipStatus = 0
            this.getUserinfo()
            this.getRights()
            this.getVipList()
        })
    },
    beforeDestroy() {
        EventBus.$off('openVip');
    },
    methods: {
        getVipList() {
            api.getViplist({ version: '1' }).then((res) => {
                if (res.code == 200 && res.data && res.data.length > 0) {
                    let viplist = res.data
                    api.getRight().then((result) => {
                        if (result.code == 200) {
                            let qylist = result.data
                            this.pricingOptions = viplist.map(item => {
                                for (let i in qylist) {
                                    let qyitem = qylist[i]
                                    if (!item.tag) {
                                        // if (['month','year','half_year'].includes(item.type) && (qyitem.type.includes('month_year'))) {
                                        //     if (item.timing) {
                                        //         item.rightImg = require('@/assets/image/vip/icon2.png')
                                        //         item.countdown = true
                                        //     }
                                        //     //2025年8月4号 要求隐藏线上会员套餐step里的内容（支持pc端，双端同步，地址：http://novel.esrke.com）
                                        //     // item.steps = qyitem.right ? qyitem.right.filter((item,i)=> i!=2) : ''
                                        //     item.steps = qyitem.right 
                                        //     // console.log('item.steps=',item.steps)
                                        // }
                                        // else if(!['month','year','half_year'].includes(item.type) && (qyitem.type.includes('month_year'))) {
                                        //     if (item.timing) {
                                        //         item.rightImg = require('@/assets/image/vip/icon2.png')
                                        //         item.countdown = true
                                        //     }
                                        //     item.steps = qyitem.right
                                        // }
                                        if(item.type === qyitem.type){
                                            if(item.timing){
                                                item.rightImg = require('@/assets/image/vip/icon2.png')
                                                item.countdown = true
                                            }
                                            item.steps = qyitem.right
                                        }else if(item.type !== qyitem.type && (qyitem.type.includes('month_year'))){
                                             if (item.timing) {
                                                item.rightImg = require('@/assets/image/vip/icon2.png')
                                                item.countdown = true
                                            }
                                            item.steps = qyitem.right
                                        }

                                    } else {
                                        if(item.type === qyitem.type){
                                            item.steps = qyitem.right
                                        }else if(item.type !== qyitem.type && (qyitem.type.includes('month_year'))){
                                            item.steps = qyitem.right
                                        }
                                        // //永久
                                        // if (['perpetual','year_ensure','year_coach'].includes(item.type) && qyitem.type === 'year_coach') {
                                        //     // item.rightImg = require('@/assets/image/vip/icon5.png')
                                        //     item.steps = qyitem.right
                                        // }
                                        // // 季度和半年
                                        // else if (['three_months','half_year'].includes(item.type) && qyitem.type === 'month_year') {
                                        //     // item.rightImg = require('@/assets/image/vip/icon4.png')
                                        //     item.steps = qyitem.right
                                        // }
                                        // else if (item.type === 'year_ensure' && qyitem.type === 'year_ensure') {
                                        //     // item.rightImg = require('@/assets/image/vip/icon4.png')
                                        //     item.steps = qyitem.right
                                        // }
                                    }
                                }
                                return item
                            })
                            console.log('pricingOptions=', this.pricingOptions)
                            //初始化默认套餐选项
                            this.handlePlanSelected(this.selectedPlan)
                        }
                    })
                }
            })
        },
        //选择套餐
        handlePlanSelected(index) {
            // if(this.selectedPlan === index) return
            this.selectedPlan = index
            this.vipItem = this.pricingOptions[this.selectedPlan]
            console.log('选中了套餐:', this.pricingOptions[index])
        },
        //获取用户信息
        getUserinfo() {
            api.getUserinfo().then((res) => {
                // console.log(res)
                if (res.code == 200) {
                    this.userInfo = res.data
                    this.loginState = true
                }
            })
        },
        //权益对比
        getRights() {
            api.getRights().then((res) => {
                if (res.code == 200) {
                    this.qunayiList = res.data
                }
            })
        },
        toLogin() {
            if (!this.loginState) {
                EventBus.$emit('openLogin')
                this.close()
            }
        },
        close() {
            this.isPopupVisible = false;
        },
        switchI(i) {
            this.vipStatus = i
        }
    }
}
</script>

<style lang="scss" scoped>
p {
    margin: 0;
    padding: 0;
}

#vip_popup {
    width: 100vw;
    height: 100vh;
    background: rgba(14, 14, 14, 0.2);
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.vip_popup {
    width: 1245px;
    height: 830px;
    background: #FFFFFF;
    border-radius: 20px;
}

.top {
    height: 103px;
    width: 1245px;
    background: url('@/assets/image/vip/top_bg.png') no-repeat;
    background-size: cover;
    position: relative;
    .top-close{
        position: absolute;
        right: 30px;
        top: 20px;
    }
}

.vip-main {
    width: 100%;
}

.pay {
    padding-left: 64px;
    padding-right: 37px;
    display: flex;
    align-items: center;

    .pay-tips {
        width: 510px;
        height: 128px;
        background-color: rgba(#D4792B, 0.2);
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-left: 32px;
        padding-right: 28px;

        p {
            position: relative;
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #71524A;

            &::before {
                content: '';
                position: absolute;
                width: 6px;
                height: 6px;
                background-color: #D4792B;
                border-radius: 50%;
                top: 7px;
                left: -10px;
            }
        }
    }
}
.custom{
    color: #FF6603;
    font-size: 24px;
}
</style>